<template>
  <div class="ranges">
    <b-dropdown :text="$t('Choose range')" class="mb-4 d-md-none select-range">
      <b-dropdown-item class="no-hover"  v-for="(value, key) in ranges" @click="$emit('clickRange', value)" :key="key">{{ key }}</b-dropdown-item>
    </b-dropdown>

    <div class="range_inputs">
      <button class="applyBtn btn btn-sm btn-ls" :disabled="canSelect" type="button" @click="$emit('clickApply')">
        {{$t('Apply')}}
      </button>
      <button class="cancelBtn btn btn-sm btn-default" type="button" @click="$emit('clickCancel')">{{$t('Cancel')}}</button>
    </div>

    <ul class="m--hidden-mobile" v-if="ranges">
      <li v-for="(value, key) in ranges" @click="$emit('clickRange', value)" :key="key">{{key}}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: ['canSelect', 'ranges'],
  }
</script>

<style scoped>
  .select-range >>> button {
    width: 210px;
  }

  .no-hover:hover {
      background: unset !important;
  }
</style>
